import { render, staticRenderFns } from "./BudgetDashboard.vue?vue&type=template&id=02246308"
import script from "./BudgetDashboard.vue?vue&type=script&lang=js"
export * from "./BudgetDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports